import styled from "styled-components";

const Contact = () => {
  return <div>Contactos</div>;
};

export default Contact;
